import { FC } from 'react';
import { Image, VStack } from '@chakra-ui/react';

import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import { useBankOverviewSearchParams } from 'features/Bank/pages/Overview/hooks/useBankOverviewSearchParams';
import VatAmount from 'features/Bank/pages/Overview/Sidebar/components/VatAmount';
import { DetailedTransaction } from 'features/Bank/pages/Overview/Sidebar/hooks/useDetailedTransactionQuery';
import { formatDate } from 'helpers/date';

import useDeleteReceiptMutation from '../../../../../../hooks/useDeleteReceiptMutation';
import BaseAttachmentCard from '../BaseAttachmentCard';
import locales from './locales';

interface ReceiptAttachmentCardProps {
  receipt: NonNullable<DetailedTransaction['receipts']>[number];
  transactionId: string;
  transactionType: DetailedTransaction['type'];
  transactionTotal: number;
}

const ReceiptAttachmentCard: FC<ReceiptAttachmentCardProps> = ({
  receipt,
  transactionId,
  transactionTotal,
  transactionType,
}) => {
  const { getTransactionReceiptSearch } = useBankOverviewSearchParams();

  const [deleteReceipt, { loading }] = useDeleteReceiptMutation({
    transactionId,
    transactionType,
  });

  return (
    <VStack spacing="space-16">
      <BaseAttachmentCard
        deleteLabel={locales.delete}
        isDeleting={loading}
        linkTo={{
          search: getTransactionReceiptSearch(transactionId, receipt.receiptId),
          state: {
            from: 'transaction-details',
          },
        }}
        onDelete={() => deleteReceipt(receipt.receiptId)}
        title={
          locales.formatString(locales.title, {
            createdAt: formatDate(receipt.createdAt, 'ddMMM'),
          }) as string
        }
      >
        <Image
          borderRadius="12px"
          fallback={<SquircleIcon name="invoice" />}
          height="space-40"
          src={receipt?.url}
          width="space-40"
        />
      </BaseAttachmentCard>

      <VatAmount receipt={receipt} transactionTotal={transactionTotal} />
    </VStack>
  );
};

export default ReceiptAttachmentCard;
